import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=3bb8fbfe&scoped=true&"
import script from "./Top.vue?vue&type=script&lang=js&"
export * from "./Top.vue?vue&type=script&lang=js&"
import style0 from "./Top.vue?vue&type=style&index=0&id=3bb8fbfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8fbfe",
  null
  
)

export default component.exports